import { ABIAppButton, AppButtonVariant } from '@ab-inbev-labs/ux-react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SettingButtonData } from './types';
import '../UserProfile.scss';

type UserSettingButtonsProps = {
  settingButtonData: SettingButtonData[];
  currentSetting: string;
  title: string;
  updateCurrentSetting: (selectedOption: string) => void;
};

export const UserSettingButtons: FC<UserSettingButtonsProps> = ({
  settingButtonData,
  currentSetting,
  title,
  updateCurrentSetting
}) => {
  const i18next = useTranslation();

  return (
    <div className="user-profile-line-container">
      <div className="user-profile-left">{title}</div>
      <div className="user-profile-right">
        {settingButtonData.map((setting) => {
          const matchesCurrent = setting.buttonValue === currentSetting;

          return (
            <ABIAppButton
              key={`setting-button-${setting.buttonValue}`}
              isNotCapitalized
              className={`user-profile-setting-accordion-button ${matchesCurrent ? 'current-setting-selection' : ''}`}
              disabled={matchesCurrent}
              variant={AppButtonVariant.Tertiary}
              onClick={() => updateCurrentSetting(setting.buttonValue)}
              data-testid={`user-profile-setting-button-${setting.buttonValue}`}
            >
              {i18next.t(setting.buttonText)}
            </ABIAppButton>
          );
        })}
      </div>
    </div>
  );
};
